import useIntl from '@/hooks/useIntl';
import { DefaultFooter } from '@ant-design/pro-components';

const Footer: React.FC = () => {
    const t = useIntl();
    const currentYear = new Date().getFullYear();

    return (
        <DefaultFooter
            style={{
                background: 'none',
                color: 'red',
            }}
            copyright={`${currentYear} ${t('app.copyright.produced')}`}
            links={[
                {
                    key: 'Esig',
                    title: 'Esig',
                    href: '#',
                    blankTarget: true,
                },
            ]}
        />
    );
};

export default Footer;
